import moment from "moment";
import { PureComponent } from "react";

import yup from "utilities/form/yup";

import { BTDatePicker } from "commonComponents/btWrappers/BTDatePicker/BTDatePicker";
import { DateDisplay } from "commonComponents/utilities/DateDisplay/DateDisplay";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
    type IGridFilterCellRenderProps,
} from "commonComponents/utilities/Grid/GridContainer.types";

type CellType = moment.Moment | undefined;

class DateFilterCell extends PureComponent<IGridFilterCellRenderProps<string, CellType>> {
    render() {
        const { cellValue, onChange, field } = this.props;
        return (
            <BTDatePicker<undefined>
                id={field.full}
                data-testid={field.full}
                value={cellValue || undefined}
                onChange={onChange}
            />
        );
    }
}

class DateCell extends PureComponent<IGridCellRenderProps<CellType>> {
    render() {
        const { cellValue } = this.props;
        return cellValue ? <DateDisplay value={cellValue} /> : null;
    }
}

export const columnDate: IClientGridColumn<string, CellType> = {
    validationSchema: yup.mixed().validMomentDate("date"),
    columnType: GridColumnType.date,
    mapper: (serverCellResponse) => (serverCellResponse ? moment(serverCellResponse) : undefined),
    FilterCell: DateFilterCell,
    Cell: DateCell,
};
